import { combineReducers } from 'redux';
import clientData from './client';
import advisorData from './advisor';
import params from './params';

const reducers = combineReducers({
  params,
  clientData,
  advisorData,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/reducers.js